// ================================
// SOCKET CONTEXT - REAL TIME
// ================================
import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const { user, role } = useAuth();

  useEffect(() => {
    if (!user) return;

    const s = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000', {
      transports: ['websocket']
    });

    s.on('connect', () => {
      console.log('🔌 Socket connected');
      // Join the right room based on role. Office accounts share the
      // admin room — they see the exact same live events (new orders,
      // pending coin purchases, etc.), same as admin; which sidebar
      // sections they can actually act on is enforced separately, both in
      // the UI (Dashboard.js's allowedTabs) and for real on the server
      // (requireSection in middleware/auth.js).
      if (role === 'admin' || role === 'office') s.emit('join:admin');
      if (role === 'driver')   s.emit('join:driver', user.name);
      if (role === 'customer') s.emit('join:customer', user.mid);
      if (role === 'staff')    s.emit('join:staff', user.username);
    });

    setSocket(s);

    return () => {
      s.disconnect();
    };
  }, [user, role]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
